<template>
  <nav id="years" class="year-nav" aria-label="re:Invent years">
    <v-container class="year-nav-inner">
      <span class="year-nav-label">Explore by year</span>
      <div class="year-buttons">
        <button
          v-for="item in years"
          :key="item.year"
          type="button"
          :class="{ active: activeYear === item.year }"
          :aria-current="activeYear === item.year ? 'true' : null"
          :aria-label="`View the ${item.year} re:Invent story`"
          @click="$emit('select', item.year)"
        >
          {{ item.year }}
        </button>
      </div>
    </v-container>
  </nav>
</template>

<script>
export default {
  name: 'RecurringEventYearNav',
  props: {
    years: { type: Array, default: () => [] },
    activeYear: { type: Number, default: null },
  },
};
</script>

<style scoped>
.year-nav { background: rgba(16, 12, 7, 0.97); border-bottom: 1px solid #3b3020; border-top: 1px solid #3b3020; position: sticky; top: 49px; z-index: 7; }
.year-nav-inner { align-items: center; display: flex; gap: 22px; }
.year-nav-label { color: #f0b13c; flex: 0 0 auto; font-family: "Oswald", sans-serif; font-size: 0.76rem; font-weight: 800; letter-spacing: 0.1em; text-transform: uppercase; }
.year-buttons { display: flex; gap: 10px; min-width: 0; overflow-x: auto; padding: 11px 2px; scrollbar-width: thin; }
.year-buttons button { background: #17130d; border: 1px solid #4a3b25; border-radius: 999px; color: #ddd; cursor: pointer; flex: 0 0 auto; font-family: "Oswald", sans-serif; font-size: 1rem; font-weight: 800; min-height: 44px; min-width: 76px; padding: 8px 20px; }
.year-buttons button:hover, .year-buttons button:focus-visible { border-color: #f0b13c; color: #fff; outline: 2px solid transparent; }
.year-buttons button.active { background: #f0b13c; border-color: #f0b13c; color: #0a0805; }
@media (max-width: 600px) { .year-nav { top: 46px; } .year-nav-inner { align-items: flex-start; flex-direction: column; gap: 4px; } .year-nav-label { padding-top: 12px; } .year-buttons { max-width: 100%; width: 100%; } }
</style>
